import { render, staticRenderFns } from "./PatientEmail.vue?vue&type=template&id=a9d07438"
import script from "./PatientEmail.vue?vue&type=script&lang=js"
export * from "./PatientEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports